import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { FileText, CheckCircle, Shield, Headphones, RefreshCw, AlertCircle } from "lucide-react";

export default function TermsOfServicePage() {
  return (
    <div className="space-y-6 animate-fade-in-up" dir="rtl">
      <div className="flex items-center gap-3">
        <FileText className="w-8 h-8 text-amber-500" />
        <h1 className="text-2xl font-bold text-white">شروط الاستخدام</h1>
      </div>

      <p className="text-slate-400">
        آخر تحديث: مارس 2026
      </p>

      <div className="grid gap-6">
        {/* مقدمة */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg">مرحباً بك في نازاريو حساباتي</CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300 space-y-3">
            <p>
              باستخدامك لهذا التطبيق، فإنك توافق على الشروط والأحكام التالية. 
              نرجو قراءتها بعناية.
            </p>
          </CardContent>
        </Card>

        {/* ما نقدمه */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-emerald-500" />
              ما نقدمه لك
            </CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300">
            <ul className="space-y-2">
              <li>• نظام متكامل لإدارة المبيعات والمخزون</li>
              <li>• تحديثات وتحسينات مستمرة</li>
              <li>• دعم فني عبر صفحة الدعم</li>
              <li>• نسخ احتياطي للبيانات</li>
              <li>• إمكانية العمل بدون إنترنت</li>
            </ul>
          </CardContent>
        </Card>

        {/* الترخيص */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg flex items-center gap-2">
              <Shield className="w-5 h-5 text-blue-500" />
              الترخيص
            </CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300 space-y-3">
            <p>
              عند شرائك للترخيص، تحصل على حق استخدام التطبيق وفقاً للباقة المختارة.
            </p>
            <ul className="space-y-2">
              <li>• الترخيص شخصي وغير قابل للنقل</li>
              <li>• يمنع إعادة بيع التطبيق أو توزيعه</li>
              <li>• يمنع محاولة نسخ أو تعديل الكود البرمجي</li>
            </ul>
          </CardContent>
        </Card>

        {/* الدعم والصيانة */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg flex items-center gap-2">
              <Headphones className="w-5 h-5 text-purple-500" />
              الدعم والصيانة
            </CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300 space-y-3">
            <p>نلتزم بتقديم:</p>
            <ul className="space-y-2">
              <li>• دعم فني خلال ساعات العمل</li>
              <li>• إصلاح الأعطال التقنية</li>
              <li>• تحديثات أمنية دورية</li>
              <li>• تحسينات على الأداء</li>
            </ul>
            <p className="text-slate-400 text-sm mt-4">
              قد تتطلب بعض عمليات الصيانة توقف مؤقت للخدمة، وسيتم إشعارك مسبقاً عند الإمكان.
            </p>
          </CardContent>
        </Card>

        {/* التحديثات */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg flex items-center gap-2">
              <RefreshCw className="w-5 h-5 text-amber-500" />
              التحديثات
            </CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300 space-y-3">
            <p>
              نعمل باستمرار على تحسين التطبيق وإضافة ميزات جديدة. 
              التحديثات تتم تلقائياً ومجانية لجميع المستخدمين.
            </p>
          </CardContent>
        </Card>

        {/* حدود المسؤولية */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg flex items-center gap-2">
              <AlertCircle className="w-5 h-5 text-slate-400" />
              حدود المسؤولية
            </CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300 space-y-3">
            <p>
              نبذل قصارى جهدنا لضمان استمرارية الخدمة وجودتها. ومع ذلك:
            </p>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>• لا نتحمل مسؤولية الأضرار الناتجة عن انقطاع الإنترنت أو الكهرباء</li>
              <li>• لا نتحمل مسؤولية الأخطاء في إدخال البيانات من قبل المستخدم</li>
              <li>• لا نتحمل مسؤولية فقدان البيانات الناتج عن سوء الاستخدام</li>
              <li>• المستخدم مسؤول عن الحفاظ على سرية بيانات الدخول</li>
            </ul>
            <p className="text-slate-400 text-sm mt-4">
              في حال حدوث أي مشكلة تقنية، نلتزم بالعمل على حلها في أسرع وقت ممكن.
            </p>
          </CardContent>
        </Card>

        {/* سياسة الاسترداد */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg">سياسة الاسترداد</CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300 space-y-3">
            <p>
              نوفر فترة تجريبية مجانية (5 أيام) لتجربة جميع الميزات قبل الشراء.
            </p>
            <p className="text-slate-400 text-sm">
              بعد إتمام عملية الشراء وتفعيل الترخيص، لا يمكن استرداد المبلغ.
            </p>
          </CardContent>
        </Card>

        {/* التواصل */}
        <Card className="bg-emerald-500/10 border-emerald-500/30">
          <CardContent className="p-6 text-center">
            <p className="text-slate-300 mb-2">
              لأي استفسارات حول شروط الاستخدام
            </p>
            <p className="text-emerald-400 font-bold">
              استخدم صفحة الدعم الفني داخل التطبيق
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
